export default __webpack_public_path__ + "static/soehne-mono-web-leicht-kursiv-da54607cf10ada5ed6d65fc5c3cda0a0.woff";